module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Battles-BC.06a9cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Battles-BC.jpg
// module id = 6E64
// module chunks = 0